@if (validationContext) {
<form [formGroup]="form">
    <rask-page pageTitle="Massändra produktinstruktioner">
        <ng-container header>
        </ng-container>
        <rask-produktinstruktioner-massedit-header
            [grundProduktinstruktionViewModel]="aktivProduktdefinition"
            [validationContext]="validationContext"
            [valdaProduktinstruktioner]="ovrigaProduktinstruktioner"
            [rootForm]="form"
            (selectedProduktinstruktionChange)="onSelectedProduktinstruktionChanged($event)"></rask-produktinstruktioner-massedit-header>
        <rask-container-block>
            <rask-tabs parameterName="tab" aid="produktinstruktiontabs" layout="child">
                <rask-tab label="Värdematris" routeId="vardematris" aid="vardematris">
                    <ng-template #tabContent>
                        <rask-vardematris
                            #vardematris
                            [viewModel]="aktivProduktdefinition"
                            [basData]="produktinstruktionBasdata"
                            [rootForm]="form">
                        </rask-vardematris>
                    </ng-template>
                </rask-tab>
                <rask-tab label="Fördelningsmatris" routeId="fordelningsmatris" aid="fordelningsmatris">
                    <ng-template #tabContent>
                        <rask-fordelningsmatris
                            #fordelningsmatris
                            [viewModel]="aktivProduktdefinition"
                            [rootForm]="form"
                            [basData]="produktinstruktionBasdata">
                        </rask-fordelningsmatris>
                    </ng-template>
                </rask-tab>
            </rask-tabs>
        </rask-container-block>
        <ng-container footerContent>
            <rask-save-button aid="save" (click)="save()" [disabled]="!canSave()"></rask-save-button>
            <rask-button aid="publicera" (click)="publish()" [disabled]="!canPublish()">Publicera</rask-button>
        </ng-container>
    </rask-page>
</form>
}